import { render, staticRenderFns } from "./MobileSliders.vue?vue&type=template&id=ce6f55c4&"
import script from "./MobileSliders.vue?vue&type=script&lang=js&"
export * from "./MobileSliders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports